import 'select2';
import 'select2/dist/css/select2';
import humps from 'humps';
import CalendarSchedulesController from './calendar_schedules_controller';
import { isEmpty } from 'lodash';
import Swal from 'sweetalert2';

export default class extends CalendarSchedulesController {
  static targets = [
    'agenda',
    'inputDate',
    'scheduleModalMask',
    'scheduleModalMessage',
    'scheduleLocation',
    'scheduleTime',
    'scheduleLevel',
    'filterSelectedSchedules',
    'filterLevel',
    'btnSelectSchedule',
    'btnUnselectSchedule'
  ];
  static values = {
    service: Object,
    locations: Array,
    selectedSchedules: Array,
    maxSchedules: Number
  };

  connect() {
    this.initializeCalendarBindings();
    this.preSelectSchedules();
    this.element.querySelectorAll('.card.batch-schedule').forEach(($card) => $card.addEventListener('click', (ev) => {
      setTimeout(() => this.openScheduleModal($card), 330) // wait animation end
    }));
  }

  closeScheduleModal(ev) {
    if (!super.closeScheduleModal(ev))
      return;

    this.selectedCard.classList.remove('.selected-batch-schedule');
  }

  openScheduleModal($card) {
    if (!$card.classList.contains('selected-batch-schedule') && !this.canOpenToSelectSchedule())
      return;

    try {
      this.selectedSchedule = humps.camelizeKeys(JSON.parse($card.dataset.schedule));
      this.selectedSchedule.dayName = $card.closest('.table-cell').dataset.dayShort;
      this.selectedSchedule.appendUID = !!this.element.dataset.appendUid ? this.element.dataset.appendUid === 'true' : true;
      this.handleSelectSchedule();
      this.selectedCard = $card;
      this.prepareScheduleFields();
      this.handleMessages();
      this.prepareModalToAnimation();
      this.scheduleModalMaskTarget.classList.add('show');
      document.querySelector('.schedule-mask').style.removeProperty('z-index');
    } catch(ex) {
      console.log(ex);
    }
  }

  handleSelectSchedule() {
    !this.selectedSchedule.dayShort && (this.selectedSchedule.dayShort = this.selectedSchedule.dayName);
    this.selectedSchedule.startTime = this.selectedSchedule.startTime.substr(0, 5);
    this.selectedSchedule.endTime = this.selectedSchedule.endTime.substr(0, 5);
    this.selectedSchedule.appendUID = !!this.element.dataset.appendUid ? this.element.dataset.appendUid === 'true' : true;
  }

  cleanSelectedSchedules() {
    this.agendaTarget.querySelectorAll('.card.selected-batch-schedule').forEach(($card) => {
      $card.classList.remove('selected-batch-schedule');
      $card.querySelectorAll('.object-values').forEach(($el) => $el.remove());
    });
    this.updateSelectedSchedules('.card.selected-batch-schedule');
  }

  async canOpenToSelectSchedule() {
    let selectedSchedulesCount = this.agendaTarget.querySelectorAll('.card.selected-batch-schedule').length;
    if (selectedSchedulesCount + 1 > this.maxSchedulesValue) {
      if (selectedSchedulesCount == 1) {
        this.selectedCard = this.agendaTarget.querySelector('.card.selected-batch-schedule');
        this.unselectSchedule(void 0, false);
        return true;
      }
      return Swal.fire({
        title: 'Atenção',
        showClass: { backdrop: 'swal2-noanimation', popup: '', },
        hideClass: { popup: '' },
        customClass: {
          cancelButton: 'btn btn-gray-primary',
          confirmButton: 'btn btn-primary mr-3'
        },
        buttonsStyling: false,
        html: 'Todos os horários necessários já estão selecionados. <br> Caso queira substituir, remova algum outro horário primeiro.',
        showCloseButton: true,
        focusConfirm: false,
        confirmButtonText: 'Ok, Entendi!',
      }).then(() => document.querySelector('.schedule-mask').click()) && false;
    }

    return true;
  }

  prepareScheduleFields() {
    let cardSelected = this.selectedCard.classList.contains('selected-batch-schedule');
    this.scheduleLevelTarget.innerHTML = this.selectedSchedule.levelName;
    this.scheduleTimeTarget.innerHTML = `${this.selectedSchedule.dayName} - ${this.selectedSchedule.startTime} às ${this.selectedSchedule.endTime}`;
    this.scheduleLocationTarget.innerHTML = isEmpty(this.selectedSchedule.locationName) ? '-' : this.selectedSchedule.locationName;
    this.btnSelectScheduleTarget.classList.toggle('!hidden', cardSelected);
    this.btnUnselectScheduleTarget.classList.toggle('!hidden', !cardSelected);
  }

  handleMessages() {
    if (this.selectedSchedule.amountEnrollments + this.selectedSchedule.amountUnfitEnrollments == this.selectedSchedule.maxCapacity) {
      this.scheduleModalMessageTarget.innerHTML = `
        <span class="bg-yellow-100 text-yellow-600 rounded-lg d-block p-2 text-sm mb-2">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
          </svg>
          Essa turma está lotada para esse dia.
        </span>
        <a class="d-block text-sm text-stone-500 mb-3" href="${this.scheduleModalMaskTarget.dataset.batchUrl.replaceAll('replace-me', this.selectedSchedule.batchId)}" target="_blank">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 18v-5.25m0 0a6.01 6.01 0 001.5-.189m-1.5.189a6.01 6.01 0 01-1.5-.189m3.75 7.478a12.06 12.06 0 01-4.5 0m3.75 2.383a14.406 14.406 0 01-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 10-7.517 0c.85.493 1.509 1.333 1.509 2.316V18" />
          </svg>

          Aumente a capacidade máxima ou selecione outra turma.

          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" />
          </svg>
        </a>
      `;
    }
  }

  selectSchedule(ev) {
    this.selectedCard.schedule = this.selectedSchedule;
    this.selectedCard.classList.add('selected-batch-schedule');
    this.updateSelectedSchedules('.card.selected-batch-schedule');
    this.appendSchedule();
    this.closeScheduleModal(ev);
  }

  unselectSchedule(_, closeModal = true) {
    this.selectedCard.classList.remove('selected-batch-schedule');
    this.selectedCard.querySelectorAll('.object-values').forEach(($el) => $el.remove());
    this.updateSelectedSchedules('.card.selected-batch-schedule');
    closeModal && this.closeModal();
  }

  preSelectSchedules() {
    if (this.selectedSchedulesValue.length == 0)
      return;

    let camelizedKeys = humps.camelizeKeys(this.selectedSchedulesValue),
      set = new Set(camelizedKeys.map((it) => it.levelId));
    if (set.size == 1 && !!set.keys().next().value) {
      this.filterLevelTarget.value = +camelizedKeys[0].levelId;
    }

    camelizedKeys.forEach((schedule) => {
      this.selectedSchedule = schedule;
      this.handleSelectSchedule();
      this.selectedCard = this.agendaTarget.querySelector(`.card.batch-schedule[id='card-batch-schedule-${schedule.batchScheduleId}']`);
      if (!!this.selectedCard) {
        this.selectedCard.schedule = this.selectedSchedule;
        this.selectedCard.classList.add('selected-batch-schedule');
        this.appendSchedule();
      }
    });

    this.updateSelectedSchedules('.card.selected-batch-schedule');
    this.selectedCard = this.selectedSchedule = undefined;
  }

  submitForm() {
    let form = this.element.closest('form');
    form.insertAdjacentHTML('afterBegin', '<button id="submit-button" class="d-none"></button>');
    form.querySelector('#submit-button').click();
  }

  get allowedKey() {
    return ['startTime', 'endTime', 'weekDay', 'batchScheduleId', 'batchId', 'locationId', 'date', 'serviceId'];
  }
}